// Per-tab session URN per docs/apis/operator-bff-tds.md §4 + §6.
//
// Each browser tab mints exactly one session URN and reuses it for the tab's
// lifetime (sessionStorage is per-tab and survives reload). The session URN is
// the authoritative key for the per-session lock index
// (`nexa:session:{session_urn}:locks`) and disconnect-driven release — so
// closing one tab releases only that tab's locks, never another tab held by
// the same operator. This is intentional (§4): operators keep one tab on a
// manifest and another on the dashboard.
//
// Sent on every lock HTTP call (`X-Session-Urn`, see lib/http.ts) and on the
// Socket.IO handshake (`auth.sessionUrn`, see lib/ws/socket.ts). The operator-
// bff reads it on acquire and on socket close; both must agree for per-tab
// release to be correct.

const STORAGE_KEY = 'nexa.sessionUrn';

// Stable within a page load even when sessionStorage is unavailable (private
// mode / SSR), so the header and the handshake carry the same value.
let ephemeral: string | null = null;

function mint(): string {
  return `urn:session:${uuidV4()}`;
}

import { uuidV4 } from '@/lib/uuid';

export function getSessionUrn(): string {
  if (typeof window === 'undefined') {
    ephemeral ??= mint();
    return ephemeral;
  }
  try {
    const existing = window.sessionStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const minted = mint();
    window.sessionStorage.setItem(STORAGE_KEY, minted);
    return minted;
  } catch {
    ephemeral ??= mint();
    return ephemeral;
  }
}
